import moment from 'moment';
import _ from 'lodash';
import NumberUtils from '../utils/NumberUtils';
import FinancialStoriesEntity from '../entities/FinancialStoriesEntity';
import FSTransactionEntity from '../entities/FSTransactionEntity';

class FinancialStoriesParser {
  getMicroTransactionsPacket(accountId, month, count) {
    const packet = {
      template: {
        file: 'microTransactions',
      },
      params: {
        amount_lower_bound: -10,
        date_lower_bound: month.fromDate,
        sort_field_date: 'details.when',
        debit_name: 'debit',
        date_field: 'details.when',
        from: 0,
        date_upper_bound: month.toDate,
        size: count,
        account_list: [accountId],
        sort_field_ordinal: 'ordinal',
        amount_range_field: 'details.amount.value',
        histogram_interval: 'month',
        date_range_field: 'details.when',
        amount_upper_bound: 0,
        credit_name: 'credit',
        order: 'desc',
        amount_field: 'details.amount.value',
      },
    };
    return packet;
  }

  getInsAndOutsPacket(accountId, month, count) {
    const packet = {
      template: {
        file: 'insAndOuts',
      },
      params: {
        date_lower_bound: month.fromDate,
        sort_field_date: 'details.when',
        debit_name: 'debit',
        date_field: 'details.when',
        from: 0,
        date_upper_bound: month.toDate,
        size: count,
        account_list: [accountId],
        sort_field_ordinal: 'ordinal',
        histogram_interval: 'month',
        date_range_field: 'details.when',
        credit_name: 'credit',
        order: 'desc',
        amount_field: 'details.amount.value',
      },
    };
    return packet;
  }

  getCashpointPacket(accountId, month, count) {
    const packet = {
      template: {
        file: 'cashpoint',
      },
      params: {
        date_lower_bound: month.fromDate,
        sort_field_date: 'details.when',
        debit_name: 'debit',
        date_field: 'details.when',
        from: 0,
        date_upper_bound: month.toDate,
        size: count,
        account_list: [accountId],
        sort_field_ordinal: 'ordinal',
        histogram_interval: 'month',
        date_range_field: 'details.when',
        credit_name: 'credit',
        order: 'desc',
        amount_field: 'details.amount.value',
        transaction_type_field: 'details.type',
        transaction_type: 'ATM',
      },
    };
    return packet;
  }

  parseFinancialStoriesResponse(type, response, accountId) {
    const bucket =
      response.aggregations.totals_of_debit_and_credits.filtered_by_date
        .buckets;
    const fsStories = [];
    _.map(bucket, (data) => {
      const fsEntity = new FinancialStoriesEntity();
      fsEntity.accountId = accountId;
      fsEntity.tileType = type;
      fsEntity.month = moment(data.key_as_string).format('YYYY-MM');
      fsEntity.sumAmount = data.monthly_spend.sum;
      fsEntity.avgAmount = _.round(data.monthly_spend.avg, 2);
      if (data.most_popular_transaction.buckets.length > 0) {
        fsEntity.minAmount = _.round(
          data.most_popular_transaction.buckets[0].key,
          2
        );
      } else {
        fsEntity.minAmount = 0;
      }
      fsEntity.transactionCount = data.doc_count;
      if (type === 'insAndOuts') {
        const creditBucket =
          response.aggregations.credit.filtered_by_date.buckets;
        const debitBucket =
          response.aggregations.debit.filtered_by_date.buckets;
        if (creditBucket.length > 0) {
          const creditData = _.find(creditBucket, {
            key_as_string: data.key_as_string,
          });
          creditData
            ? (fsEntity.creditAmount = creditData.monthly_spend.sum)
            : (fsEntity.creditAmount = 0);
        } else {
          fsEntity.creditAmount = 0;
        }
        if (debitBucket.length > 0) {
          const debitData = _.find(debitBucket, {
            key_as_string: data.key_as_string,
          });
          debitData
            ? (fsEntity.debitAmount = debitData.monthly_spend.sum)
            : (fsEntity.debitAmount = 0);
        } else {
          fsEntity.debitAmount = 0;
        }
      }
      if (fsEntity.transactionCount > 0) {
        fsEntity.transactions = [];
        const hits = response.hits.hits;
        _.map(hits, (transaction) => {
          const fsTransactionEntity = new FSTransactionEntity();
          fsTransactionEntity.date = moment(
            transaction._source.details.when
          ).format('DD MMM YY');
          fsTransactionEntity.description = transaction._source.suggested_terms;
          fsTransactionEntity.type = transaction._source.details.type;
          fsTransactionEntity.posted = transaction._source.details.posted;
          if (
            transaction._source.metadata.tags &&
            transaction._source.metadata.tags.length > 0
          ) {
            fsTransactionEntity.tag =
              transaction._source.metadata.tags[0].value;
          } else if (
            transaction._source.metadata.categories &&
            transaction._source.metadata.categories.length > 0
          ) {
            fsTransactionEntity.tag =
              transaction._source.metadata.categories[0].value;
          }
          fsTransactionEntity.amount = NumberUtils.appendCurrency(
            '{}',
            transaction._source.details.amount.value
          );
          fsEntity.transactions.push(fsTransactionEntity);
        });
      }
      fsStories.push(fsEntity);
    });
    return fsStories;
  }
}

export default new FinancialStoriesParser();
